export const environmentProd = {
  api_base_url:
    'https://auction1-authadm.metaljunction.com/gateway/orchestrator/',
  camundaURL: 'https://auction1-camunda.metaljunction.com/engine-rest/',
  //report_base_url: 'https://auction1report.metaljunction.com/',
  report_base_url: 'https://auction1report.metaljunction.com/',
  production: true,
  recaptcha: {
    siteKey: '6LfhXTAUAAAAAPpH7Ko4z2uzMMfrDy5sSS_T7wgr',
  },
  key: {
    pdfViewer: '002517bef1884e60bad76017d2ead6b1' /* for Race Admin */,
    awsCreds: {
      url: 'https://auctiondoc.metaljunction.com/',
      region: 'ap-south-1',
      bucket: 'raceserverdocument',
      bucket2: 'raceserverdocument',
      pdfPath: 'MetalJunctionDocuments/',
      docPath: 'MetalJunctionDocuments/',
      expiresIn: 3600,
      accessKey: 'AKIAU6GDVGH4OXGRKQX6',
      secretKey: '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',
    },
    DEFAULT_ACCESS_KEY_ID: 'AKIA57EKRFUABLBQR3OY',
    DEFAULT_SECRET_KEY_ID: 'HxsPKNkWSEt4v3jbeIG6GWnksMV0TjZMV5EgAjJa',
  },
  getIpUrl: '',
  version: require('../../package.json').version,
  rakAnalyticsBaseUrl: 'https://analytics.metaljunction.com/',
  metalAnalyticsBaseUrl: 'https://dashboard.metaljunction.com/',
  pythonApi: 'https://mtreport-sitanalytics.metaljunction.com/sit/metal/reportAnalysis/',
  RECAPTCHA_V2_KEY: '6LcE1IMpAAAAAInUg3iOzIS8B5Ld26PREBeaBi4O',
  RECAPTCHA_V3_KEY: '6LcE1IMpAAAAAGlY01MMnMXj6_G_STpEaYwXQQif',
  RAKUTEN_SERVICE_VERSION: '1.0.0',
  RAKUTEN_COLLECTOR:
    'https://http-collector-observability.sixthsense.rakuten.com/oap',
  RAKUTEN_SERVICE_NAME: 'RACE METAL ADMIN PROD',
  RAKUTEN_AUTH:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZWFtSWQiOiJhYzA1OWVmYS1lOGE3LTQxNDAtOGM5MS03MmQ1NmJiODIwZGUiLCJiaWxsaW5nX2lkIjoiMmYwOWQyNWEtMjAyZS00ODg2LWFjOGYtN2JiZjFmMzI3NDJkIiwiaWF0IjoxNzIxMjc4MDA0LCJhdWQiOiJvYXAiLCJpc3MiOiJzaXh0aC1zZW5zLWF1dGgifQ.dKfdpdpbIxKljvMQflT2OR8MfKctn2HDBvpD89iPWJA',
};
